import { render, staticRenderFns } from "./PZD100Result.vue?vue&type=template&id=61233b4e&scoped=true&"
import script from "./PZD100Result.vue?vue&type=script&lang=js&"
export * from "./PZD100Result.vue?vue&type=script&lang=js&"
import style0 from "./PZD100Result.vue?vue&type=style&index=0&id=61233b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61233b4e",
  null
  
)

export default component.exports